import { CognitoAuth } from '@classgo/shared/auth';

import { config } from './config';

/**
 * The one Cognito wrapper of the console (staff SRP client).
 */
export const cognito = new CognitoAuth(config.cognito);
